module.exports = __webpack_public_path__ + "img/close_icon.547fd58f.svg";